import { FallcoClass } from "../classes/FallcoClass";
import "bootstrap-notify/bootstrap-notify";

/**
 *
 * @constructor
 */
class Notify extends FallcoClass {
  constructor() {
    super();

    let notify_settings = {
      position: "fixed",
      placement: {
        from: "top",
        align: "center",
      },
      z_index: 2000000,
      newest_on_top: true,
      template:
        '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close btn-close" data-notify="dismiss"></button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>',
    };

    this.default_messages = {
      title: {
        tag: "h5",
        class: "",
      },
      info: {
        title: "",
        message: "",
      },
      warning: {
        title: "",
        message: "",
      },
      success: {
        title: "",
        message: "Operazione correttamente effettuata.",
      },
      error: {
        title: "",
        message:
          "A causa di un errore l'operazione non \u00e8 andata a buon fine.",
      },
    };

    // Controlla se ci si trova dentro un iframe
    if (window.frameElement) {
      notify_settings["element"] = parent.document.body;
    }

    // Imposta i parametri di default di Bootstrap Notifys
    $.notifyDefaults(notify_settings);

    return super.expose_to_public("notify", this);
  }

  updateDefaultSettings(newSettings) {
    $.notifyDefaults(newSettings);

    // console.log("notify", $.notifyDefaults())
  }

  /**
   *
   * @param {string} [message]
   */
  success(message, persist) {
    let settings = { type: "success" };

    if (persist) {
      settings.delay = 0;
    }

    $.notify(this._validate_settings("success", message), settings);
  }

  /**
   *
   * @param message
   */
  info(message, persist) {
    let settings = { type: "info" };

    if (persist) {
      settings.delay = 0;
    }

    $.notify(this._validate_settings("info", message), settings);
  }

  /**
   *
   * @param message
   * @param persist
   */
  warning(message, persist) {
    let settings = { type: "warning" };

    if (persist) {
      settings.delay = 0;
    }

    $.notify(this._validate_settings("warning", message), settings);
  }

  /**
   *
   * @param {string} [message]
   */
  error(message, persist) {
    let settings = { type: "danger" };

    if (persist) {
      settings.delay = 0;
    }

    $.notify(this._validate_settings("error", message), settings);
  }

  _validate_settings(type, params) {
    let final_settings = {
      message: "",
      title: "",
    };

    if (params && typeof params === "object") {
      final_settings.message =
        params["message"] || this.default_messages[type].message;
      final_settings.title =
        params["title"] || this.default_messages[type].title;
    } else if (params && typeof params === "string") {
      final_settings.message += params;
    } else {
      final_settings.message = this.default_messages[type].message;
    }

    switch (type) {
      case "info":
      case "warning":
      case "success":
        if (params && params["extra_message"]) {
          final_settings.message += "<br>" + params["extra_message"];
        }
        break;
      case "error":
        if (params && params["extra_message"]) {
          final_settings.message +=
            "<br><br><strong>Errore:</strong><br>" + params["extra_message"];
        }
        break;
    }

    if (final_settings.title) {
      let title_tag = $("<" + this.default_messages.title.tag + ">");
      title_tag.addClass(this.default_messages.title.class);
      title_tag.html(final_settings.title);

      final_settings.title = title_tag[0].outerHTML;
    }

    return final_settings;
  }
}

export default new Notify();
